import { useState } from "react";
import { ArrowLeft, MainButton } from "../components";
import { primaryColor } from "../constants/constants";
import { updatePassword } from "../api/UserInfo";
import ShowPasswordEye from "../components/Icons/ShowPasswordEye";
import HidePasswordEye from "../components/Icons/HidePasswordEye";
import { useNavigate } from "react-router-dom";

const ChangePassword = () => {
  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [obscurePassword, setObscurePassword] = useState(true);
  const [obscureConfirmPassword, setObscureConfirmPassword] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handlePasswordVisibility = () => {
    setObscurePassword(!obscurePassword);
  };

  const handleConfirmPasswordVisibility = () => {
    setObscureConfirmPassword(!obscureConfirmPassword);
  };

  const validateField = (field, errorSetter, errorMessage) => {
    if (!field) {
      errorSetter(errorMessage);
      return false;
    }
    return true;
  };

  const saveChangesClicked = () => {
    setPasswordError("");
    setConfirmPasswordError("");
    setErrorMessage("");

    // Validate required fields
    if (
      !validateField(password, setPasswordError, "The password field is required") ||
      !validateField(confirmPassword, setConfirmPasswordError, "The confirm password field is required")
    ) {
      return;
    }

    // Validate password length (min 8 characters)
    if (password.length < 8) {
      setPasswordError("The password must be at least 8 characters long");
      return;
    }

    // Validate that password and confirm password match
    if (password !== confirmPassword) {
      setConfirmPasswordError("Passwords do not match");
      return;
    }

    setIsLoading(true);
    const rawD = JSON.stringify({ newPassword: password });

    updatePassword(rawD)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === true) {
          setErrorMessage("Password updated successfully!");

          // Redirect to "Virtual Cards" after 3 seconds
          setTimeout(() => {
            navigate("/virtual-cards");
          }, 3000);
        } else {
          setErrorMessage(result.message || "Failed to update password.");
        }
        setIsLoading(false);
      })
      .catch(() => {
        setErrorMessage("An error occurred. Please try again.");
        setIsLoading(false);
      });
  };

  return (
    <div className="w-full h-100 flex justify-center items-center bg-slate-10">
      <div className="w-full flex flex-col justify-center items-center">
        <div className="w-[90%] max-w-[600px] text-slate-700 p-2 sm:p-8 shadow-sm rounded-lg bg-white">
          {/* Back Button */}
          <div onClick={() => navigate(-1)} className="flex items-center pb-3">
            <ArrowLeft className="h-6 w-6 cursor-pointer" />
            <div
              className={`text-[${primaryColor}] w-full flex justify-center font-bold text-lg text-center`}
            >
              Change Password
            </div>
          </div>
          <hr className="py-4" />

          {/* New Password Input */}
          <div className="py-2">
            <div className="flex items-start flex-col w-full gap-1">
              <label>
                New Password <span className="text-red-500">*</span>
              </label>
              <div
                className={`w-full flex border ${
                  passwordError ? "border-red-500" : "border-slate-600/50"
                } rounded-md`}
              >
                <input
                  type={obscurePassword ? "password" : "text"}
                  value={password}
                  placeholder="New Password"
                  onChange={(ev) => setPassword(ev.target.value)}
                  className="outline-none rounded-md px-3 py-2 w-full"
                />
                <button className="mr-2" onClick={handlePasswordVisibility}>
                  {obscurePassword ? (
                    <ShowPasswordEye className="h-6 w-6" />
                  ) : (
                    <HidePasswordEye className="h-6 w-6" />
                  )}
                </button>
              </div>
              <label className="text-red-500 text-sm">{passwordError}</label>
            </div>
          </div>

          {/* Confirm Password Input */}
          <div className="py-2">
            <div className="flex items-start flex-col w-full gap-1">
              <label>
                Confirm Password <span className="text-red-500">*</span>
              </label>
              <div
                className={`w-full flex border ${
                  confirmPasswordError ? "border-red-500" : "border-slate-600/50"
                } rounded-md`}
              >
                <input
                  type={obscureConfirmPassword ? "password" : "text"}
                  value={confirmPassword}
                  placeholder="Confirm Password"
                  onChange={(ev) => setConfirmPassword(ev.target.value)}
                  className="outline-none rounded-md px-3 py-2 w-full"
                />
                <button className="mr-2" onClick={handleConfirmPasswordVisibility}>
                  {obscureConfirmPassword ? (
                    <ShowPasswordEye className="h-6 w-6" />
                  ) : (
                    <HidePasswordEye className="h-6 w-6" />
                  )}
                </button>
              </div>
              <label className="text-red-500 text-sm">{confirmPasswordError}</label>
            </div>
          </div>

          {/* Error Message */}
          {errorMessage && (
            <div className="text-center text-md text-green-800">{errorMessage}</div>
          )}

          {/* Save Changes Button */}
          <div className="py-2">
            <MainButton
              label={"Save Changes"}
              onClick={saveChangesClicked}
              isLoading={isLoading}
            />
             <div className="w-full border-t border-gray-300 my-10 "></div>
        <p className="text-xs text-center text-gray-300">
          &copy; {new Date().getFullYear()} AshCard. All rights reserved. Powered by PSI.
        </p>
      
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
